<h1 mat-dialog-title class="dialog-title">
  <mat-icon>{{ isCreditsTarget ? 'toll' : 'all_inclusive' }}</mat-icon>
  Promote to {{ targetLabel }}
</h1>

<form #promoteForm="ngForm">
  <mat-dialog-content class="dialog-content">
    <section class="transition">
      <div class="state">
        <span class="state-title">Now</span>
        <div class="state-chips">
          @for (type of currentTypes; track type) {
            <span
              class="type-chip"
              [class.removed]="isRemoved(type)"
              [class.kept]="!isRemoved(type)">
              {{ label(type) }}
            </span>
          } @empty {
            <span class="type-chip none">None</span>
          }
        </div>
      </div>
      <mat-icon class="arrow">arrow_forward</mat-icon>
      <div class="state">
        <span class="state-title">After execution</span>
        <div class="state-chips">
          @for (type of targetTypes; track type) {
            <span
              class="type-chip"
              [class.added]="isAdded(type)"
              [class.kept]="!isAdded(type)">
              {{ label(type) }}
            </span>
          }
        </div>
      </div>
    </section>

    @if (hasConflict) {
      <gymfinder-alert variant="warning" size="condensed" class="dialog-alert">
        <div class="alert-body">
          This gym currently has <strong>both Credits and Unlimited</strong>,
          which is not a valid FR/BE configuration. This schedule will fix it by
          keeping only <strong>{{ targetLabel }}</strong
          >.
        </div>
      </gymfinder-alert>
    }

    @if (alreadyInTarget) {
      <gymfinder-alert variant="light" size="condensed" class="dialog-alert">
        <div class="alert-body">
          This gym is already <strong>{{ targetLabel }}</strong
          >.
          @if (isCreditsTarget) {
            Scheduling this will only update the credits price.
          } @else {
            Scheduling this will only make sure the credits configuration is
            removed.
          }
        </div>
      </gymfinder-alert>
    }

    <gymfinder-alert variant="info" size="condensed" class="dialog-alert">
      <div class="alert-body">
        <strong>Plus 1 is not affected.</strong>
        @if (hasPlus1) {
          This gym has Plus 1 and it will stay active, together with
          {{ targetLabel }}.
        } @else {
          This gym has no Plus 1 right now; this schedule won't add it.
        }
        Only Credits and Unlimited are switched.
      </div>
    </gymfinder-alert>

    @if (isCreditsTarget) {
      @if (currentTypes.includes(MembershipType.UNLIMITED)) {
        <gymfinder-alert
          variant="warning"
          size="condensed"
          class="dialog-alert">
          <div class="alert-body">
            <strong>Unlimited will be removed</strong> on the execution date.
            Members will need credits to check in at this gym.
          </div>
        </gymfinder-alert>
      }

      <div class="dialog-field">
        <mat-form-field class="price-field">
          <mat-label>Standard credits price</mat-label>
          <input
            matInput
            type="number"
            name="price"
            required
            [min]="MIN_PRICE"
            [max]="MAX_PRICE"
            step="1"
            pattern="^[0-9]+$"
            [(ngModel)]="price"
            #priceInput="ngModel" />
          <span matTextSuffix>credits</span>
          @if (priceInput.invalid) {
            <mat-error>
              Enter a whole number between {{ MIN_PRICE }} and {{ MAX_PRICE }}.
            </mat-error>
          } @else {
            <mat-hint>
              Required, must be a whole number between {{ MIN_PRICE }} and
              {{ MAX_PRICE }}. Applied on the execution date.
            </mat-hint>
          }
        </mat-form-field>
      </div>
    } @else {
      <gymfinder-alert variant="warning" size="condensed" class="dialog-alert">
        <div class="alert-body">
          <strong>The credits configuration will be removed</strong> on the
          execution date.
          @if (currentPrices.length > 0) {
            <div class="current-config">
              Current configuration:
              @for (p of currentPrices; track $index) {
                <span class="price-pill"
                  >{{ p }} {{ p === 1 ? 'credit' : 'credits' }}</span
                >
              }
            </div>
          } @else {
            <div class="current-config">
              No credits price is configured today.
            </div>
          }
        </div>
      </gymfinder-alert>
    }

    <div class="dialog-field">
      <mat-form-field class="date-field">
        <mat-label>Execution date</mat-label>
        <input
          name="scheduled"
          matInput
          [min]="minDate"
          [matDatepicker]="picker"
          [(ngModel)]="scheduledAt"
          required
          disabled />
        <mat-hint>YYYY-MM-DD, applied by the nightly schedule job</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker disabled="false"></mat-datepicker>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button type="button" (click)="closeDialog()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="submit()"
      [disabled]="!canSubmit || promoteForm.invalid">
      Schedule promotion
    </button>
  </mat-dialog-actions>
</form>
